// Import model
import { Settings } from '../models/Settings';

// Import base class serializer

// Import dependency types (models and enums used in properties)

// Import dependency serializers (for complex types)

// Import derived type serializers (for polymorphic deserialization)

/**
 * Serializer for Settings - handles JSON serialization and deserialization with type validation
 */
export class SettingsSerializer {
  /**
   * Deserializes a JSON string into a Settings instance
   */
  static deserialize(json: string): Settings {
    const obj = JSON.parse(json);
    return this.fromObject(obj);
  }

  /**
   * Deserializes a plain object into a Settings instance
   */
  static fromObject(obj: any): Settings {
    if (!obj) {
      throw new Error('Cannot deserialize null or undefined to Settings');
    }


    const instance: Settings = {
      clientId: obj['clientId'] as string | undefined,
      clientIdName: obj['clientId|Name'] as string | undefined,
      entityId: obj['entityId'] as string | undefined,
      entityIdName: obj['entityId|Name'] as string | undefined,
      name: obj['name'] as string | undefined,
      description: obj['description'] as string | undefined,
      id: obj['_id'] as string | undefined,
      createdDate: obj['createdDate'] as string | undefined,
      lastModifiedOn: obj['LastModifiedOn'] as string | undefined,
      directionsProvider: obj['directionsProvider'] as string | undefined,
      phoneCallProvider: obj['phoneCallProvider'] as string | undefined,
      smsProvider: obj['smsProvider'] as string | undefined,
      theme: obj['theme'] as string | undefined,
    };

    return instance;
  }

  /**
   * Deserializes a JSON string into an array of Settings instances
   */
  static deserializeArray(json: string): Settings[] {
    const arr = JSON.parse(json);
    if (!Array.isArray(arr)) {
      throw new Error('Expected JSON array');
    }
    return arr.map(obj => this.fromObject(obj));
  }

  /**
   * Serializes a Settings instance to a JSON string
   */
  static serialize(instance: Settings): string {
    return JSON.stringify(this.toObject(instance));
  }

  /**
   * Converts a Settings instance to a plain object
   */
  static toObject(instance: Settings): any {
    return {
      'clientId': instance.clientId,
      'clientId|Name': instance.clientIdName,
      'entityId': instance.entityId,
      'entityId|Name': instance.entityIdName,
      'name': instance.name,
      'description': instance.description,
      '_id': instance.id,
      'createdDate': instance.createdDate,
      'LastModifiedOn': instance.lastModifiedOn,
      'directionsProvider': instance.directionsProvider,
      'phoneCallProvider': instance.phoneCallProvider,
      'smsProvider': instance.smsProvider,
      'theme': instance.theme,
    };
  }

  /**
   * Serializes an array of Settings instances to a JSON string
   */
  static serializeArray(instances: Settings[]): string {
    return JSON.stringify(instances.map(inst => this.toObject(inst)));
  }
}
